module.exports = __webpack_public_path__ + "6c685b487160cdc5bc8d3294f6c350c9.svg";